import BaseUpdateRequest from '@/models/Shared/BaseUpdateRequest';
import CancelledReason from '@/models/Shared/CancelledReason';

export default class CancelBookingRoleWorkerShiftRequest extends BaseUpdateRequest {
    cancelledReason: CancelledReason;
}